import React from "react";
import BillingNavigationBar from "../../../shared/components/settings/billing/BillingNavigationBar";
import InvoiceOverview from "../../../shared/components/settings/billing/InvoiceOverview";
import InvoiceBilledTo from "../../../shared/components/settings/billing/InvoiceBilledTo";
import InvoicePayment from "../../../shared/components/settings/billing/InvoicePayment";
import useFetchInvoiceById from "../../../shared/api/payment/useFetchInvoiceById";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MakePayment from "../../../shared/components/settings/billing/MakePayment";
import SideModal from "../../../shared/components/general/SideModal";
import { BiArrowBack } from "react-icons/bi";

export default function BillingInvoice() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const action = query.get("action");

    const navigate = useNavigate();
    const { invoiceId, schoolId } = useParams();
    const { data: invoice } = useFetchInvoiceById(invoiceId);

    function handlePayment() {
        navigate(
            `/${schoolId}/settings/billing/invoices/${invoiceId}?action=payment`
        );
    }

    function closeSideModal() {
        navigate(`/${schoolId}/settings/billing/invoices/${invoiceId}`);
    }

    return (
        <div className={"page"}>
            {/**
      |--------------------------------------------------
      | Page title
      |--------------------------------------------------
      */}
            <div className="mb-10 flex items-center justify-between">
                <h1 className="page_title">Invoice</h1>
            </div>

            {/**
      |--------------------------------------------------
      | Navigation bar
      |--------------------------------------------------
      */}
            <BillingNavigationBar activeIndex={2} />

            {/**
        |--------------------------------------------------
        | Main content
        |--------------------------------------------------
        */}
            <div className="main_content !pb-0 mb-10">
                <button
                    className="py-1 px-1 ml-3 mb-3 flex items-center gap-2 text-yankee_blue hover:bg-primary/5 hover:text-primary"
                    onClick={() => navigate(-1)}
                >
                    <BiArrowBack className="text-sm" />
                    <small>Go back</small>
                </button>

                {/**
        |--------------------------------------------------
        | Invoice Overview
        |--------------------------------------------------
        */}
                <InvoiceOverview
                    invoice={invoice}
                    handlePayment={handlePayment}
                />
            </div>

            <div className="main_content mb-10">
                {/**
        |--------------------------------------------------
        | Payment  details
        |--------------------------------------------------
        */}
                <InvoicePayment invoice={invoice} />
            </div>

            <div className="main_content">
                {/**
        |--------------------------------------------------
        | Billing address
        |--------------------------------------------------
        */}
                <InvoiceBilledTo invoice={invoice} />
            </div>

            <SideModal isVisible={action} closeSideModal={closeSideModal}>
                {action === "payment" ? (
                    <MakePayment
                        invoice={invoice}
                        handleCancel={closeSideModal}
                    />
                ) : null}
            </SideModal>
        </div>
    );
}
